const FormFieldSelect = ({
    label,
    fieldName,
    defaultValue,
    stateObject,
    updateStateObject,
    required = false,
    options,
    optionKey,
    optionValue,
    optionDisplay,
    formatValue = null,
    additionalProps = {},
    className = "formField"
}) => {
    return (
        <div className={`${className}`}>
            <label>{label}{required ? "*" : ""}: </label>
            <select
                defaultValue={defaultValue}
                onChange={(e) => updateStateObject({
                    ...stateObject,
                    [fieldName]: formatValue ? formatValue(e.target.value) : e.target.value
                })}
                name={fieldName}
                required={required}
                {...additionalProps}
            >
                <option value=""></option>
                {options.map(option => (
                    <option
                        key={option[optionKey]}
                        value={option[optionValue]}
                    >
                        {option[optionDisplay]}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default FormFieldSelect;